import * as firebase from "firebase";
// Add the Firebase products that you want to use

import { store, UserModule } from "@/store";
import { getModule } from "vuex-module-decorators";
import Vue from "vue";
import UserModel from "@/models/User";
import router from "@/router";
import eventBus, { DeclaredEvents } from "@/EventBus";

let firebaseConfig = {
    apiKey: process.env.VUE_APP_apiKey,
    authDomain: process.env.VUE_APP_authDomain,
    databaseURL: process.env.VUE_APP_databaseURL,
    projectId: process.env.VUE_APP_projectId,
    storageBucket: process.env.VUE_APP_storageBucket,
    messagingSenderId: process.env.VUE_APP_messagingSenderId,
    appId: process.env.VUE_APP_appId,
    measurementId: process.env.VUE_APP_measurementId,
};

const userModule = getModule(UserModule, store);

async function init(resolve: (value?: firebase.app.App | PromiseLike<firebase.app.App> | undefined) => void, reject: (reason?: any) => void) {
    // Initialize Firebase
    try {
        const firebaseApp = firebase.initializeApp(firebaseConfig);
        firebase.auth().useDeviceLanguage();

        resolve(firebaseApp);

        firebaseApp.auth().onAuthStateChanged(user => {
            userModule.setLoadingUser(true);
            // console.log("firebase.auth().onAuthStateChanged user", user);
            if (user) {
                UserModel.create(user).then(newUser => {
                    userModule.changeUser(newUser).then(() => {
                        if (router.currentRoute.path === "/login") {
                            router.push("/");
                        }
                        eventBus.$emit(DeclaredEvents.login, newUser);
                    });
                });
            } else {
                userModule.changeUser(UserModel.empty()).then(() => {
                    router.push("login");
                });
            }
        });
    } catch (error) {
        reject(error);
    }

    // console.log("Firebase inicicializado!", firebaseApp);
}
export const firebaseInitPromise: Promise<firebase.app.App> = new Promise((resolve, reject) => {
    if (!firebaseConfig.apiKey) {
        fetch("/__/firebase/init.json").then(async response => {
            firebaseConfig = await response.json();
            // console.log("Initi firebase from hosting", firebaseConfig);
            init(resolve, reject);
        });
    } else {
        init(resolve, reject);
    }
});

// console.log("config", firebaseConfig);
